import DiagramUtils from "../utils/DiagramUtils";
import DiagramRefProperty from "../diagrams/DiagramRefProperty";
import LinkLineModel from "../diagrams/LinkLineModel";

export default class PluginLinks {

    constructor(designer, {
        linkType = "ArrowLinkLineModel",
    } = {}) {

        this.designer = designer;
        this.linkType = linkType;
    }

    install() {

        const dom = this.designer.dom;
        dom.addEventListener("mousedown", this.onMouseDownHandler = this.onMouseDown.bind(this));
        dom.addEventListener("mouseup", this.onMouseUpHandler = this.onMouseUp.bind(this));
        dom.addEventListener("mousemove", this.onMouseMoveHandler = this.onMouseMove.bind(this));
    }

    uninstall() {

        this.shutdown = true;

        const dom = this.designer.dom;
        dom.removeEventListener("mousedown", this.onMouseDownHandler);
        dom.removeEventListener("mouseup", this.onMouseUpHandler);
        dom.removeEventListener("mousemove", this.onMouseMoveHandler);
        this.isDragging = false;
        this.designer.properties.isDiagramDragging = false;
        this.designer.properties.isDiagramLinking = false;
        this.link = null;
    }

    onMouseDown(e) {

        if (e.button !== 0)
            return;
        if (this.link)
            return;

        this.designer.properties.isDiagramDragging = true;
        this.designer.properties.isDiagramLinking = true;
        this.isDragging = true;

        const pt = this.designer.absoluteScreenPointToView({ x: e.clientX, y: e.clientY });
        this.backupMouseStart = pt;
        let model = this.designer.pluginSelection.findAllWithoutPaper(pt).filter(c => !(c instanceof LinkLineModel));
        model = model.length && model[0];
        let anchor = model && this.getAnchor(pt, model);

        const ds = DiagramUtils.diagrams;
        this.link = ds[this.linkType].createModel();
        if (anchor)
            this.link.startAnchor = anchor.anchor;

        this.link.dataContext.refs = [new DiagramRefProperty(), new DiagramRefProperty()];
        this.link.endLocation = pt;

        if (model) {
            this.link.dataContext.refs[0]._sys.ref = model;
            this.link.dataContext.refs[0].id = model.id;
            this.link.dataContext.refs[0].enabled = true;
        }
        else {
            this.link.startLocation = pt;
        }

        this.designer.addModel(this.link);
        e.preventDefault();
    }

    onMouseUp(e) {

        if (e.button !== 0)
            return;
        if (!this.isDragging)
            return;

        this.designer.properties.isDiagramDragging = false;
        this.designer.properties.isDiagramLinking = false;
        this.isDragging = false;

        const pt = this.designer.absoluteScreenPointToView({ x: e.clientX, y: e.clientY });
        let model = this.designer.pluginSelection.findAllWithoutPaper(pt).filter(c => !(c instanceof LinkLineModel));
        model = model.length && model[0];

        if (model) {
            let anchor = this.getAnchor(pt, model);
            this.link.dataContext.refs[1]._sys.ref = model;
            this.link.dataContext.refs[1].id = model.id;
            this.link.dataContext.refs[1].enabled = true;
            this.link.endAnchor = anchor.anchor;
            // this.link.endLocation = null;
        }
        else {
            this.link.endLocation = pt;
        }

        this.designer.selectedItems = this.link;
        this.link.startLocationDisplayOffset = null;
        this.link.endLocationDisplayOffset = null;
        this.link.dataContext.refs = [...this.link.dataContext.refs];
        this.link = null;

        e.preventDefault();
    }

    onMouseMove(e) {

        if (!this.isDragging)
            return;

        const pt = this.designer.absoluteScreenPointToView({ x: e.clientX, y: e.clientY });
        this.link.endLocation = pt;

        e.preventDefault();
    }

    getAnchor(pt, model) {

        const location = model.getViewLocation();
        const size = model.getViewSize();

        const pts = [
            {
                x: location.x,
                y: location.y + size.height / 2,
                anchor: "left",
            },
            {
                x: location.x + size.width / 2,
                y: location.y,
                anchor: "top",
            },
            {
                x: location.x + size.width,
                y: location.y + size.height / 2,
                anchor: "right",
            },
            {
                x: location.x + size.width / 2,
                y: location.y + size.height,
                anchor: "bottom",
            }
        ];

        let min = 99999999999;
        let minItem = null;
        for (let i = 0; i < pts.length; i++) {
            const current = pts[i];
            const dx = current.x - pt.x;
            const dy = current.y - pt.y;

            const d = dx * dx + dy * dy;
            if (d < min) {
                min = d;
                minItem = current;
            }
        }

        return minItem;
    }
}